
module.exports = require('./ReactS3Uploader');



//////////////////
// WEBPACK FOOTER
// ./~/react-s3-uploader/index.js
// module id = 1561
// module chunks = 0